const MobileLogin = (({ jQuery: $ }) => {
    class MobileLogin {
        constructor($node) {
            this.$node = $($node);
            this.$user = this.$node.find('[data-js="mobile-login-username"]');
            this.$pass = this.$node.find('[data-js="mobile-login-password"]');
            this.$submit = this.$node.find('[data-js="mobile-login-submit"]');
            this.$formToClone = $('form[name="login"]');
            this.$formAction = null;
        }

        cloneForm() {
            let formAction = this.$formToClone.attr('action');
            this.formAction = formAction;
            let formMethod = this.$formToClone.attr('method');
            let formName = this.$formToClone.attr('name');
            let formOnSubmit = this.$formToClone.attr('onsubmit');

            let userName = this.$formToClone
                .find('input[type="text"]')
                .attr('name');
            let passName = this.$formToClone
                .find('input[type="password"]')
                .attr('name');
            let submitName = this.$formToClone
                .find('input[type="submit"]')
                .attr('name');

            let $hiddenField = this.$formToClone
                .find('input[type="hidden"]')
                .clone(true);

            this.$node.append($hiddenField);

            this.$node.attr({
                action: formAction,
                method: formMethod,
                name: formName,
                onsubmit: formOnSubmit,
            });

            this.$pass.attr('name', passName);
            this.$user.attr('name', userName);
            this.$submit.attr('name', submitName);
        }

        init() {
            this.cloneForm();
        }
    }

    return {
        init({ selector }) {
            return new MobileLogin(selector).init();
        },
    };
})(window);

export default Object.create(MobileLogin);
